// src/utils/messageBox.ts
import { ElMessageBox } from 'element-plus'

interface MessageBoxOptions {
  title?: string
  message: string
  type?: 'success' | 'warning' | 'info' | 'error'
  confirmButtonText?: string
  cancelButtonText?: string
  showClose?: boolean
  showCancelButton?: boolean
  showConfirmButton?: boolean
  closeOnClickModal?: boolean
  closeOnPressEscape?: boolean
}

// 封装消息框工具
export const $msgbox = {
  // 确认框
  confirm(
    message: string,
    title: string = '提示',
    options?: Omit<MessageBoxOptions, 'message' | 'title'>
  ) {
    return ElMessageBox.confirm(message, title, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      ...options
    })
  },

  // 提示框
  alert(
    message: string,
    title: string = '提示',
    options?: Omit<MessageBoxOptions, 'message' | 'title'>
  ) {
    return ElMessageBox.alert(message, title, {
      confirmButtonText: '确定',
      ...options
    })
  },

  // 输入框
  prompt(
    message: string,
    title: string = '提示',
    options?: Omit<MessageBoxOptions, 'message' | 'title'>
  ) {
    return ElMessageBox.prompt(message, title, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      ...options
    })
  },

  // 通用方法
  show(options: MessageBoxOptions) {
    return ElMessageBox(options)
  }
}
